<template>
  <div class="app-container">
    <!--工具栏-->
    <div class="head-container">
      <el-input v-model="form.key" clearable placeholder="输入商品名称搜索" style="width: 200px" class="filter-item" />
      <el-input v-model="form.commodityCode" clearable placeholder="输入商品编码搜索" style="width: 200px" class="filter-item" />
      <el-input v-model="form.sku" clearable placeholder="输入商品规格搜索" style="width: 200px" class="filter-item" />
      <el-button class="filter-item" size="mini" type="success" icon="el-icon-search"
        @click="searchKey(form)">搜索</el-button>
    </div>
    <!--表单组件-->
    <!--表格渲染-->
    <el-table :data="tableData" size="small" style="width: 100%" @row-dblclick="doSelect">
      <el-table-column ref="table" prop="image" label="商品图片">
        <template slot-scope="scope">
          <a :href="scope.row.image" style="color: #42b983" target="_blank"><img :src="scope.row.image" alt="点击打开"
              class="el-avatar" /></a>
        </template>
      </el-table-column>
      <el-table-column prop="spuName" label="商品名称" />
      <el-table-column prop="unique" label="商品编码" />
      <el-table-column prop="sku" label="商品规格" />
      <el-table-column prop="price" label="商品价格" />
      <el-table-column prop="itemCode" label="物料编码" />
      <el-table-column prop="itemName" label="物料名称" />
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="doSelect(scope.row)" icon="el-icon-check">
            选择
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :total="total" style="margin-top: 8px" layout="total, prev, pager, next"
      @current-change="pageChange" />
  </div>
</template>

<script>
import { getProductsBySku } from "@/api/indexpage.js";
export default {
  name: "bpm",
  components: {},
  props: ["uItem", "dialogTableVisible"],
  data() {
    return {
      listquery: {
        keyword: "",
        commodityCode: '',
        sku: "",
        limit: 10,
        page: 1,
      },
      total: null,
      dialogFormVisible: false,
      form: {
        key: "",
        commodityCode: '',
        sku: '',
        pageNum: 1,
      },
      tableData: [],
    };
  },
  created() {
    this.test();
  },
  methods: {
    async test(form, page) {
      if(form){
        this.listquery.keyword = form.key;
        this.listquery.commodityCode = form.commodityCode;
        this.listquery.sku = form.sku;
      }
      this.listquery.page = page;
      var res = await getProductsBySku(this.listquery);
      if (res.status === 200) {
        this.tableData = res.data;
        this.total = res.total;
      } else {
        this.$message.warning(res.msg);
      }
    },
    searchKey(form) {
      this.test(form);
    },
    pageChange(e) {
      this.test(this.form, e);
    },
    doSelect(data) {
      let a = data;
      this.$emit("dialogRes", a, this.uItem);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/addInventory/bpm.vue